<script lang="ts">
  export let label = '';
  export let bindGroup = [];
  export let value = '';
  export let width = '18';
  export let height = '18';
  export let disabled = false;
  export let checked: boolean | undefined = undefined; // 'checked' can be passed from parent component

  // Use the passed 'checked' prop if available, otherwise fallback to checking bindGroup
  $: {
    if (checked === undefined) {
      checked = bindGroup.includes(value);
    }
  }
  $: {
    if (bindGroup) {
      checked = bindGroup.includes(value);
    }
  }

  /**
   * The function that is called when the checkbox is changed.
   * The function filters the bindGroup array by removing the value if the checkbox is unchecked.
   * If the checkbox is checked, it adds the value to the bindGroup array.
   *
   * @param {Event} e - The event object.
   * @param {string} value - The value of the checkbox.
   */
  function onChange(e, value) {
    const { checked } = e.target;
    // Update the bindGroup array based on the checkbox state.
    if (checked) {
      bindGroup = Array.from(new Set([...bindGroup, value]));
    } else {
      bindGroup = bindGroup.filter(item => item !== value);
    }
  }
</script>

<label class="extra-checkbox">
  {label}
  <input
    type="checkbox"
    {value}
    {checked}
    on:change={e => onChange(e, value)}
    {disabled}
    style="height: {height}px; width:{width}px"
  />
</label>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .extra-checkbox {
    padding: 10px;
  }
  input[type='checkbox'] {
    position: relative;
    box-sizing: content-box;
    width: 14px;
    height: 14px;
    cursor: pointer;
    -webkit-appearance: none;
    border: 1px solid $icon-only-icon-blue;
    background-color: $primary-white;
    border-radius: 2px;
  }

  input[type='checkbox']:before {
    content: '';
    display: block;
    // transition: transform 200ms;
  }

  input[type='checkbox']:checked:before {
    width: 8px;
    height: 14px;
    margin: 0px 4px;
    border-bottom: 2px solid $icon-only-icon-blue;
    border-right: 2px solid $icon-only-icon-blue;
    transform: rotate(45deg);
  }
  :global([dir='rtl']) input[type='checkbox']:checked:before {
    border-bottom: 2px solid $icon-only-icon-blue;
    border-right: 0 !important;
    border-left: 2px solid $icon-only-icon-blue !important;
    transform: rotate(-45deg) !important;
  }
</style>
